import React from 'react';
import { classIf, iconSportCssClass } from '../../data/utils';

function CalendarSportSelector(props) {
    function clickHandler() {
        props.changeSport(props.id);
    }

    const icoSport = iconSportCssClass(props.id, props.iconClass);
    return (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <a className={"pointer" + classIf(props.selected, 'filtro-attivo-cal-sport')} onClick={clickHandler}>
            <div className="d-flex flex-column align-items-center">
                <div className="position-relative pl-4 pr-4">
                    <div className={`img-fluid ico-sport ${icoSport}`}></div>
                    <span className="contatore-sport-calendario">{props.events.length}</span>
                </div>
                <span>{props.desc}</span>
            </div>
        </a>
    );
}

export default CalendarSportSelector;